import React, { useCallback, useState } from 'react';
import DsButton from '../../DsButton';
import DsModal from '../../DsModal';
import EventMaterialExplorer from '../../events/EventMaterialExplorer';

export type EventNoteSelectableMaterial = {
  id?: number | string;
  event_material_id?: number | string;
  title?: string;
  file_name?: string;
  file_size?: number;
  content_type?: string;
  effective_share_with_artists?: boolean;
};

type EventNoteMaterialPickerProps = {
  open: boolean;
  eventUuid?: string | null;
  role?: 'admin' | 'artist';
  canUpload?: boolean;
  initialMaterials?: EventNoteSelectableMaterial[];
  onClose: () => void;
  onConfirm: (_materials: EventNoteSelectableMaterial[]) => void;
};

export default function EventNoteMaterialPicker({
  open,
  eventUuid,
  role = 'admin',
  canUpload = false,
  initialMaterials = [],
  onClose,
  onConfirm,
}: EventNoteMaterialPickerProps) {
  const [selectedMaterials, setSelectedMaterials] = useState<EventNoteSelectableMaterial[]>(initialMaterials);
  const handleSelectionChange = useCallback((materials: EventNoteSelectableMaterial[]) => {
    setSelectedMaterials(materials);
  }, []);
  const privateSelectionCount = role === 'admin'
    ? selectedMaterials.filter((material) => material.effective_share_with_artists !== true).length
    : 0;

  return (
    <DsModal
      open={open}
      onClose={onClose}
      title="イベント資料から選択"
      ariaLabel="イベント資料から選択"
      footer={null}
      size="lg"
    >
      <div className="note-material-picker">
        <p className="note-material-picker__guide">
          資料を選択してください。{canUpload ? 'この画面でアップロードした資料も、そのまま選択できます。' : ''}
        </p>
        {privateSelectionCount > 0 ? (
          <p className="note-material-picker__warning" role="note">
            非共有資料が{privateSelectionCount}件含まれています。公開ノートに保存すると、ノートを閲覧できるアーティストにも表示されます。
          </p>
        ) : null}
        {open && eventUuid ? (
          <EventMaterialExplorer
            eventUuid={eventUuid}
            role={role}
            canView
            canUpload={canUpload}
            canManage={false}
            canDownload
            showTitle={false}
            emptyLabel="このフォルダに資料はありません"
            selectionMode
            initialSelectedMaterials={initialMaterials}
            onSelectionChange={handleSelectionChange}
          />
        ) : null}
        <div className="note-material-picker__actions">
          <span className="note-material-picker__selection">
            {selectedMaterials.length ? `${selectedMaterials.length}件選択中` : '資料を選択してください'}
          </span>
          <DsButton type="button" variant="secondary" onClick={onClose}>キャンセル</DsButton>
          <DsButton type="button" variant="create" onClick={() => onConfirm(selectedMaterials)}>
            選択した資料を追加
          </DsButton>
        </div>
      </div>
    </DsModal>
  );
}
